import { render } from "./EventviewBets.vue?vue&type=template&id=7cddc47c"
import script from "./EventviewBets.vue?vue&type=script&lang=js"
export * from "./EventviewBets.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__